import httpClient from '@/services/httpClient'
import { Text } from '@conexasaude/conexa-hero'
import { Icon } from '@conexasaude/iconography/icons'
import { FunctionComponent, useCallback, useEffect, useState } from 'react'
import { useStyles } from './styles'
import { RenderIf } from '@/components/RenderIf'
import { useLocation } from 'react-router-dom'

const ConciergeAps: FunctionComponent = () => {
  const styles = useStyles()
  const [cellPhone, setCellPhone] = useState('')
  const { pathname } = useLocation()

  const getConciergeCellPhone = useCallback(async () => {
    try {
      const response = httpClient.get(
        `primary-health-care/obtain-concierge-cellphone`,
      )

      const conciergePhoneNumber = (await response)?.data?.object
      setCellPhone(conciergePhoneNumber)
    } catch (err) {
      console.log(err)
    }
  }, [])

  useEffect(() => {
    getConciergeCellPhone()
  }, [getConciergeCellPhone])

  const redirectToWppCall = async () => {
    window.open(
      `https://api.whatsapp.com/send?1=pt_BR&phone=${cellPhone}&text=Ol%C3%A1,%20sou%20paciente%20da%20sua%20equipe.%20Pode%20me%20ajudar%20?`,
    )
  }

  return (
    <RenderIf condition={Boolean(cellPhone) && pathname !== '/clari'}>
      <div css={styles.whatsappLinkWrapper}>
        <div css={styles.whatsappLink}>
          <a
            onClick={redirectToWppCall}
            target="_blank"
            data-cy="link-health-teams-talk-to-concierge"
          >
            <div css={styles.iconTalk}>
              <Icon name="doctor-talk" size={28} color="white" />
              <Text variant="link" color="white">
                Fale com sua Concierge
              </Text>
            </div>
          </a>
        </div>
      </div>
    </RenderIf>
  )
}

export { ConciergeAps }
